module.exports = __webpack_public_path__ + "static/img/code.89d6dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.png
// module id = 9OQK
// module chunks = 0